import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ProductImage = ({ productId, imageName, size = "w-full h-48" }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    
    const fetchImageUrl = async () => {
      if (!productId) {
        setLoading(false);
        setError(true);
        return;
      }
      
      try {
        setLoading(true);
        setError(false);
        
        // Get the S3 presigned URL from backend
        const response = await axios.get(
          `${API}/api/settings/products/${productId}/image?url_only=true`
        );
        
        if (isMounted && response.data?.url) {
          setImageUrl(response.data.url);
        } else if (isMounted) {
          setError(true);
        }
      } catch (err) {
        console.log('Could not get product image URL:', productId);
        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchImageUrl();

    return () => {
      isMounted = false;
    };
  }, [productId]);

  if (loading) {
    return (
      <div className={`${size} bg-gray-100 flex items-center justify-center rounded animate-pulse`}>
        <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (error || !imageUrl) {
    return (
      <div className={`${size} bg-gray-200 flex items-center justify-center text-gray-400 rounded`}>
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    );
  }

  return (
    <img 
      src={imageUrl} 
      alt={imageName || 'Product'} 
      className={`${size} object-cover rounded`}
      onError={() => setError(true)}
    />
  );
};

export default ProductImage;
